import React, {createRef, useEffect, useRef, useState} from "react";


interface ScrollControllerProps {
    parentRef:React.RefObject<any>
    setCurrentSection:(i:number) => void;
}

const ScrollController:React.FC<ScrollControllerProps> = (props) => {
    const arrLength = React.Children.count(props.children);
    const [elRefs, setElRefs] = useState([] as Array<React.RefObject<any>>);
    const elRefsRef = useRef(elRefs);
    useEffect(() => {
        elRefsRef.current = elRefs;
    },[elRefs])

    useEffect(() => {
        // add or remove refs
        setElRefs(elRefs => (
            // @ts-ignore
            Array(arrLength).fill().map((_, i) => elRefs[i] || createRef())
        ));
    }, [arrLength]);
    useEffect(() => {
        console.log("scroll registered");
        props.parentRef.current.addEventListener("scroll",()=>{
            let currentId = -1;
            for(let i = 0; i < elRefsRef.current.length; i++){
                const clientRect = elRefsRef.current[i].current.getBoundingClientRect();
                if(Math.abs(clientRect.y)< 20){
                    currentId = i;
                }
            }
            console.log(currentId);
            if(currentId != -1){
                props.setCurrentSection(currentId);
            }
        })
    },[]);

    return(
        <React.Fragment>
            {React.Children.map(props.children,(e,i) => {
                return(
                    <React.Fragment>
                        <div ref={elRefs[i]}/>
                        {e}
                    </React.Fragment>
                )
            })}
        </React.Fragment>
    )
}

export default ScrollController;